import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Delete as DeleteIcon, Edit as EditIcon,  } from '@mui/icons-material';
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";
import { ModalV2 } from "components/Modal/ModalV2";
import { useRuleValidator } from "hooks/useRuleValidator";
import { useToggle } from 'hooks/useToggle';
import { PERMISSIONS } from "router/permissions";
import { ColumnContainer } from 'utils/columnsStyle';
import { 
  warehouseSelected,
  editWarehouseMode,
  deleteWarehouse,
} from 'redux/actions/warehousesCatalog/warehousesCatalogActions';
import { LOADING_ACTIONS } from 'redux/reducers/warehousesCatalog/warehousesTypes';

const { CATALOGS_STORAGE_DELETE } = PERMISSIONS;

export const columns = [
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Número Económico</span> ),
    accessor: "number",
    filterable: true,
    filterMethod: (filter, row) =>
      row.number
        ? row.number.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Estación</span> ),
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) =>
      row.station
        ? row.station.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Marca</span> ),
    accessor: "brand",
    filterable: true,
    filterMethod: (filter, row) =>
      row.brand
        ? row.brand.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Capacidad</span> ),
    accessor: "capacity",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.capacity) 
        ? String(row.capacity).includes(filter.value)
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Serie</span> ),
    accessor: "serialNumber",
    filterable: true,
    filterMethod: (filter, row) =>
      row.serialNumber
        ? row.serialNumber.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Fecha de expiración</span> ),
    accessor: "expirationDate",
    filterable: true,
    filterMethod: (filter, row) =>
      row.expirationDate
        ? row.expirationDate.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Descripción</span> ),
    accessor: "description",
    filterable: true,
    filterMethod: (filter, row) =>
      row.description
        ? row.description.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Permiso CRE</span> ),
    accessor: "creLicense",
    filterable: true,
    filterMethod: (filter, row) =>
      row.creLicense
        ? row.creLicense.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Acciones</span> ),
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const canDeleteWarehouse = useRuleValidator(CATALOGS_STORAGE_DELETE);
      const isLoadingComp = useSelector(({ search }) => search.isLoadingComp);
      const [openDelete, _, setOpenDelete] = useToggle();

      const openEdit = () => {
        dispatch(editWarehouseMode());
        original.modal();
        dispatch(warehouseSelected(original.id));
      };

      const handleDelete = () => {
        dispatch(deleteWarehouse(original.id, () => setOpenDelete(false)));
      };

      const buttons = [
        {
          Icon: EditIcon,
          color: 0,
          onClick: openEdit,
          tooltip: "Modificar almacén",
        },
        {
          Icon: DeleteIcon,
          color: 3,
          onClick: () => setOpenDelete(true),
          tooltip: "Eliminar almacén",
          validation: canDeleteWarehouse,
        },
      ];

      return (
        <ColumnContainer>
          <ActionsButtons buttons={buttons} />
          {openDelete && (
            <ModalV2
              title="¿Seguro que desea eliminar este almacén?"
              open={openDelete}
              onClose={() => setOpenDelete(false)}
              onSubmit={handleDelete}
              justConfirm
              isLoading={isLoadingComp?.[LOADING_ACTIONS.DELETE]}
              confirmColor="warning"
            />
          )}
        </ColumnContainer>
      )
    },
  },
];